import {NgModule} from "@angular/core";

import {SharedModule} from "../shared/shared.module";
import {SearchScopeComponent} from "./components/form-controls/search-scope/search-scope.component";
import {SearchTabProxyComponent} from "./components/form-controls/search-tab-proxy/search-tab-proxy.component";
import {MediaTabComponent} from "./components/tabs/media-tab/media-tab.component";
import {AdvancedSearchLinkComponent} from "./components/tabs/products-tab/components/advanced-search-link/advanced-search-link.component";
import {ProductsTabComponent} from "./components/tabs/products-tab/products-tab.component";
import {SearchTabDirective} from "./components/tabs/search-tab.directive";
import {UmbracoPagesTabComponent} from "./components/tabs/umbraco-pages-tab/umbraco-pages-tab.component";

import {ContentSearchComponent} from "./content-search.component";

import {ContentSearchConfigService} from "./services/content-search-config.service";
import {ContentSearchParamsFactoryService} from "./services/factories/content-search-params-factory.service";
import {SuggestedWordComponent} from "./components/suggested-word/suggested-word.component";

@NgModule({
    declarations: [
        ContentSearchComponent,
        SearchScopeComponent,
        SearchTabProxyComponent,
        ProductsTabComponent,
        MediaTabComponent,
        UmbracoPagesTabComponent,
        SearchTabDirective,
        AdvancedSearchLinkComponent,
        SuggestedWordComponent
    ],
    imports: [
        SharedModule
    ],
    exports: [
        ContentSearchComponent
    ],
    providers: [
        ContentSearchParamsFactoryService,
        ContentSearchConfigService
    ],
    entryComponents: [
        ProductsTabComponent,
        MediaTabComponent,
        UmbracoPagesTabComponent
    ]
})
export class ContentSearchModule {
}
